import { ModalProjectComponent } from "@component/modal-project/modal-project.component";
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { Project } from "@model/Project";
import { ProjectService } from "@service/project.service";
import { PlanningService } from "@service/planning.service";
import { Protocol } from "@model/Protocol";

import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ModalDeleteComponent } from "@component/modal-delete/modal-delete.component";
import { ModalInvitationComponent } from "@component/modal-invitation/modal-invitation.component";
import { ModalTransferComponent } from "@component/modal-transfer/modal-transfer.component";

import { ResearchQuestion } from "@model/ResearchQuestion";

import * as moment from "moment";
import { ModalProjectStatusComponent } from "@component/modal-project-status/modal-project-status.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Template } from "@model/Template";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "@service/auth.service";
import { CommentService } from "@service/comments.service";
import { Subscription } from "rxjs";
import { Message } from "@model/Message";
import { Events } from "@service/events.service";
import { Location } from "@angular/common";
import { DocumentService } from "@service/documents.service";
import { HttpEvent, HttpEventType } from "@angular/common/http";
import { saveAs } from "file-saver";

export interface Participant {
  id: number;
  name: string;
  role: string;
}

const saveFile = (blobContent: Blob, fileName: string) => {
  const blob = new Blob([blobContent], { type: "application/octet-stream" });
  saveAs(blob, fileName);
};

@Component({
  selector: "app-card-project",
  templateUrl: "./card-project.component.html",
  styleUrls: ["./card-project.component.scss"],
})
export class CardProjectComponent implements OnInit, OnDestroy, AfterViewInit {
  public colors: any[] = [
    "card-default",
    "card-primary",
    "card-success",
    "card-danger",
    "card-warning",
    "card-info",
    "card-bdc",
  ];
  public bdStatus: any[] = [
    "development",
    "presenting",
    "subject",
    "published",
  ];
  public progresStatus: any[] = [
    "Em desenvolvimento",
    "Apresentação",
    "Submetido",
    "Publicado",
  ];
  public bdPresentingStatus: any[] = ["qualification", "vindication"];
  public presentingStatus: any[] = ["Qualificação/TCC1", "Defesa/TCC2"];
  public statusProject: string = "";
  public presentingStatusProject: string = "";
  public researchQuestions: Array<ResearchQuestion> = [];
  public researchQuestionsText: string = "";
  public mainGoal = "";
  public justification = "";
  public leaveProject: boolean = false;
  public showDropdownMyStudents: boolean = false;
  public deleteProject: boolean = false;
  public selectedProjectId: number;
  public protocol: Protocol;
  private repositoryId: number;
  
  @Input() transferProjectId: number; 
  @Input() selectedRepositoryId: number;
  @Input("project") project: Project;
  @Input("showDropdown") showDropdown: boolean;

  modalOptions: NgbModalOptions;

  private subscriptions = new Subscription();

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private planningService: PlanningService,
    private projectService: ProjectService,
    private commentService: CommentService,
    private authService: AuthService,
    private toast: ToastrService,
    private readonly events: Events,
    private readonly location: Location,
    private readonly activatedRoute: ActivatedRoute,
    private documentService: DocumentService
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      size: "lg",
    };
  }

  ngOnInit() {
    this.repositoryId = this.activatedRoute.snapshot.params["id"];
    this.borderLeftColorCard();
    this.subscriptions.add(
      this.planningService
        .getProtocol(this.project.id)
        .subscribe((protocol: Protocol) => {
          this.researchQuestions = protocol.protocol_questions;

          this.researchQuestions.forEach((researchQuestion) => {
            this.researchQuestionsText += String(
              researchQuestion.description + ", "
            );
          });
          if (this.researchQuestionsText != "") {
            this.researchQuestionsText = this.researchQuestionsText.slice(
              0,
              -2
            );
          }

          if (JSON.parse(protocol.objectives)) {
            JSON.parse(protocol.objectives).general.forEach((objective) => {
              this.mainGoal += objective.description + ", ";
            });
            if (this.mainGoal != "") {
              this.mainGoal = this.mainGoal.slice(0, -2);
            }
          }

          if (protocol.justification) {
            this.justification = protocol.justification;
          }
        })
    );
  }

  public forecastDay(forecast_date): string {
    let forecast = moment(forecast_date, "MM-DD-YYYY").diff(new Date(), "days");
    if (forecast < 0)
      return `Se passou ${forecast * -1} dia${
        forecast > 1 || forecast * -1 > 1 ? "s" : ""
      }`;

    return `${forecast} dia${forecast > 1 || forecast * -1 > 1 ? "s" : ""}`;
  }

  public clone(project: Project) {
    this.projectService.clone(project.id).subscribe(() => {});
  }

  openProject(project: Project) {
    let modal = this.modalService.open(
      ModalProjectComponent,
      this.modalOptions
    );
    modal.componentInstance.project = project;
  }

  openInvitation(project: Project) {
    const userName = this.authService.user.name;
    const projectUser = project.authors.find(
      (author) => author.name === userName
    );
    if (projectUser.author_principal) {
      let modal = this.modalService.open(
        ModalInvitationComponent,
        this.modalOptions
      );
      modal.componentInstance.project = project;
      modal.componentInstance.repositoryId = this.repositoryId;
      modal.result.then((result) => {
        if (result !== "uninvite") {
          this.toast.success("Convite enviado com sucesso!");
        }
      });
    } else {
      this.toast.error("Você não pode fazer o convite!");
    }
  }

  openStatus(project: Project) {
    let modal = this.modalService.open(ModalProjectStatusComponent);
    modal.componentInstance.project = project;
  }

  openDelete(project: Project) {
    let modal = this.modalService.open(ModalDeleteComponent);

    modal.componentInstance.record = {
      id: project.id,
      uri: "projects",
      description: `${project.title}`,
    };
  }

  openHistoric(project: Project) {
    this.router.navigate(["projects", project.id, "historical"]);
  }

  openSettings(project: Project) {
    this.router.navigate(["projects", project.id, "configuration"]);
  }


  transferProject(project: Project) {
    this.transferProjectId = project.id;
    let modal = this.modalService.open(ModalTransferComponent, this.modalOptions);
    modal.componentInstance.projectId = this.transferProjectId;
    modal.componentInstance.repositoryId = this.repositoryId;
  }


  downloadPdf(project: Project) {
    this.documentService
      .pdf(project.id, "anything")
      .subscribe((events: HttpEvent<any>) => {
        if (events.type === HttpEventType.DownloadProgress) {
          const percent = Math.round((events.loaded / events.total) * 100);
          console.log("Download progress: ", percent + "%");
        } else if (events.type === HttpEventType.Response) {
          saveFile(events.body, project.title + ".pdf");
        }
      });
  }

  checkStatus(projectStatus: string): string {
    const index = this.bdStatus.indexOf(projectStatus);
    return (this.statusProject = this.progresStatus[index]);
  }
  checkPresentingStatus(presentingStatus: string): string {
    if (presentingStatus) {
      const index = this.bdPresentingStatus.indexOf(presentingStatus);
      if (index == -1) {
        return "";
      } else {
        return (this.presentingStatusProject =
          "/" + this.presentingStatus[index]);
      }
    } else return "";
  }

  setOpenProject() {
    this.projectService.setOpenProject(this.project);
    this.events.setCurrentProjectId(this.project.id);
  }

  borderLeftColorCard() {
    let obj = document.querySelectorAll(".card");
    let i = 0;
    obj.forEach((el) => {
      if (i > 7) {
        i = 0;
      }
      $(el).addClass(this.colors[i++]);
    });
  }

  onLeaveProject(project) {
    this.projectService
      .uninvite(project.id, [this.authService.user.id], this.repositoryId)
      .subscribe(
        (project: Project) => {
          this.toast.success(Message.SUCCESS);
          this.events.broadcast("leaveProject");
        },
        (handler) => {
          console.log(handler);
        }
      );
  }

  ngAfterViewInit() {
    const userName = this.authService.user.name;
    const projectUser = this.project.authors.find(
      (author) => author.name === userName
    );
    if (projectUser) {
      this.leaveProject =
        !projectUser.author_principal &&
        this.project.authors.map((author) => author.name).includes(userName);
      setTimeout(() => {
        this.deleteProject = projectUser.author_principal;
      }, 0);
    }
    setTimeout(() => {
      // if (this.location.path().includes('my-students')) {
      //   this.showDropdownMyStudents = true;
      // }
      this.showDropdownMyStudents = this.showDropdown === false;
    }, 0);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
